// extracted by mini-css-extract-plugin
export default {"root":"DcqQVCvWzBe_MzM6iDvK","main":"qz1ZkRpPBCtxW8EpNSzw"};